import React, { useEffect } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { CARGO_CODES } from "constants/permissions";
import { AuthState } from "store/ducks/auth/types";
import { useReceberPropostaVendasDetalhe } from "services/api/AppWeb_PropostaVendas/receber-proposta-vendas-detalhe";
import NavCommon from "components/@navHeader";
import { Skeleton } from "@mui/material";
import * as Styles from "./styles";
import ProductCard from "./ProductCard";

interface Props {
  idLead: string;
}

const PropostaVendasPage: React.FC<Props> = (props: Props) => {
  const history = useHistory();
  const params = useParams<{
    idOportunidade: string;
    idLeadCorretor: string;
    numeroCotacao: string;
    idLead: string;
  }>();

  const {
    data: dataDetalheProposta,
    refetch: refetchProposta,
    isLoading,
    isRefetching,
  } = useReceberPropostaVendasDetalhe({
    idOportunidade: params?.idOportunidade,
  });

  const { usuarioCia, codigoCargo2013 } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);

  const isCorretor = codigoCargo2013 === CARGO_CODES.CORRETOR;
  const isCoordenadorCia = codigoCargo2013 === CARGO_CODES.COORDENADOR_CIA;

  useEffect(() => {
    refetchProposta();
  }, [params?.idOportunidade]);

  const handleBack = () => {
    history.goBack();
    localStorage.setItem("@sell.it/previousScreen", window.location.href);
  };

  return (
    <>
      <NavCommon
        breadcrumbs={
          isCorretor || isCoordenadorCia || usuarioCia
            ? [
                {
                  path: `/lead-detail/${params.idLeadCorretor}/proposition-detail/${params.numeroCotacao}`,
                  name: "Propostas",
                },
                {
                  path: `/lead-detail/${params.idLeadCorretor}/proposition-detail/${params.numeroCotacao}/${params.idOportunidade}`,
                  name: "Proposta de vendas",
                },
              ]
            : [
                {
                  path: `/leads`,
                  name: `Carteira`,
                },
                {
                  path: `/lead-detail/${params.idLeadCorretor}`,
                  name: `Detalhes do lead`,
                },
                {
                  path: `/lead-detail/${params.idLeadCorretor}/proposition-detail/${params.numeroCotacao}`,
                  name: "Propostas",
                },
                {
                  path: `/lead-detail/${params.idLeadCorretor}/proposition-detail/${params.numeroCotacao}/${params.idOportunidade}`,
                  name: "Proposta de vendas",
                },
              ]
        }
        showButtonNew
        onBack={handleBack}
        open
        onChangeActionNew={undefined}
      />
      <Styles.Container>
        <Styles.BodyContainer>
          <Styles.RowSpace>
            <Styles.Row>
              <Styles.Title>Proposta de vendas</Styles.Title>
              <Styles.BackButton onClick={handleBack}>Voltar</Styles.BackButton>
            </Styles.Row>
          </Styles.RowSpace>

          {isLoading ? (
            <Skeleton variant="rectangular" height={1000} />
          ) : (
            <ProductCard
              dataDetalheProposta={dataDetalheProposta}
              refetchProposta={refetchProposta}
              dataDetalheOportunidade={{
                idOportunidade: params?.idOportunidade,
                editavel: true,
              }}
              onClose={handleBack}
              idLead={params?.idLead}
              isRefetching={isRefetching}
            />
          )}
        </Styles.BodyContainer>
      </Styles.Container>
    </>
  );
};

export default PropostaVendasPage;
